type YAxisWithLabelsProps = {
  yMin?: number
  yMax?: number
  interval?: number
  ctx: CanvasRenderingContext2D
  canvasHeight: number
}

const DEFAULT_OFFSET = 40

export function drawYAxisWithLabels({
  yMin = 0,
  yMax = 100,
  interval = 20,
  ctx,
  canvasHeight
}: YAxisWithLabelsProps): void {
  const paddingTop = 5
  const paddingBottom = 5

  ctx.font = '10px Inter'
  ctx.fillStyle = 'rgba(82, 102, 122, 1)'
  ctx.textAlign = 'right'

  for (let y = yMin; y <= yMax; y += interval) {
    const yPos = mapYToCanvas(y, yMin, yMax, paddingTop, canvasHeight - paddingBottom)
    ctx.fillText(y.toString(), DEFAULT_OFFSET - 5, yPos + 4)
  }
}

function mapYToCanvas(
  value: number,
  min: number,
  max: number,
  top: number,
  bottom: number
): number {
  const range = max - min
  if (range === 0) return bottom
  return bottom - ((value - min) / range) * (bottom - top)
}
